import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractServicePrivate } from '../service/abstract.service.private';

@Injectable({
  providedIn: 'root'
})
export class HistoricoEventoService extends AbstractServicePrivate {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'historicoEvento';
  }

  procurarHistoricoEventoPorFiltro(filtro: Object): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/filtro`, filtro);
  }

}
